import React from 'react';
import Modal from '@components/shared/Modal';

interface Props {
  title: string;
  isOpen: boolean;
  closeModal: () => void;
  children: React.ReactNode;
}

const GlobalModal: React.FC<Props> = ({ title, isOpen, closeModal, children }) => (
  <Modal modalOpen={isOpen} onClose={closeModal} title={title} paddingDesktop="0" paddingMobile="0" width="770px">
    {children}
  </Modal>
);

export default GlobalModal;
